function initVehicleCompatibility(data) {
    const container = document.getElementById('vehicle-compatibility-container');
    
    if (!data || !Array.isArray(data) || data.length === 0) {
        container.innerHTML = '<div class="acp-no-data">No compatibility data available</div>';
        return;
    }
    
    // 提取所有品牌、年份和车型选项
    const allYears = [...new Set(data.map(item => item.year))].filter(Boolean).sort();
    const allMakes = [...new Set(data.map(item => item.make))].filter(Boolean).sort();
    const allModels = [...new Set(data.map(item => item.model))].filter(Boolean).sort();
    
    // 检查数据中是否存在Trim字段且值不为"/"
    const hasTrim = data.some(item => item.trim && item.trim !== "/");
    
    // 动态生成表格HTML
    let tableHTML = `
        <div class="acp-search-section">
            <input type="text" class="acp-search-box" placeholder="Search by Year, Make, Model..." id="acpSearchInput">
            
            <div class="acp-filter-controls">
                <select class="acp-filter-select" id="acpYearSelect">
                    <option value="">Year [All]</option>
                    ${allYears.map(year => `<option value="${year}">${year}</option>`).join('')}
                </select>
                
                <select class="acp-filter-select" id="acpMakeSelect">
                    <option value="">Make [All]</option>
                    ${allMakes.map(make => `<option value="${make}">${make}</option>`).join('')}
                </select>
                
                <select class="acp-filter-select" id="acpModelSelect">
                    <option value="">Model [All]</option>
                    ${allModels.map(model => `<option value="${model}">${model}</option>`).join('')}
                </select>
                
                <button class="acp-filter-btn" id="acpFilterBtn">Filter</button>
            </div>
        </div>
        
        <div class="acp-table-container">
            <div class="acp-table-header">Vehicle Compatibility List</div>
            <div class="acp-table-wrapper">
                <table class="acp-table">
                    <thead>
                        <tr>
                            <th>Year</th>
                            <th>Make</th>
                            <th>Model</th>
                            ${hasTrim ? '<th>Trim</th>' : ''}
                            <th>Engine</th>
                        </tr>
                    </thead>
                    <tbody id="acpTableBody">
    `;

    // 添加行数据
    data.forEach(item => {
        tableHTML += `
            <tr>
                <td>${item.year || 'N/A'}</td>
                <td>${item.make || 'N/A'}</td>
                <td>${item.model || 'N/A'}</td>
                ${hasTrim ? `<td>${item.trim || 'N/A'}</td>` : ''}
                <td>${item.engine || 'N/A'}</td>
            </tr>
        `;
    });

    tableHTML += `
                        </tbody>
                    </table>
                </div>
                <div class="acp-table-note">
                    * Scroll to see all compatible vehicles. Showing <span id="acpVisibleCount">${data.length}</span> of ${data.length} vehicles.
                </div>
            </div>
        `;

    // 将表格添加到容器
    container.innerHTML = tableHTML;

    // 添加搜索功能
    const searchInput = document.getElementById('acpSearchInput');
    const makeSelect = document.getElementById('acpMakeSelect');
    const yearSelect = document.getElementById('acpYearSelect');
    const modelSelect = document.getElementById('acpModelSelect');
    const filterBtn = document.getElementById('acpFilterBtn');
    const tableBody = document.getElementById('acpTableBody');
    const rows = tableBody.getElementsByTagName('tr');
    const visibleCount = document.getElementById('acpVisibleCount');

    // 更新可见行数显示
    function updateVisibleCount() {
        let count = 0;
        for (let row of rows) {
            if (row.style.display !== 'none') {
                count++;
            }
        }
        visibleCount.textContent = count;
    }

    // 执行过滤
    function performFilter() {
        const searchTerm = searchInput.value.toLowerCase().trim();
        const selectedYear = yearSelect.value.toLowerCase().trim();
        const selectedMake = makeSelect.value.toLowerCase().trim();
        const selectedModel = modelSelect.value.toLowerCase().trim();

        for (let i = 0; i < rows.length; i++) {
            const row = rows[i];
            const cells = row.getElementsByTagName('td');
            let matchFound = true;

            // 检查搜索条件
            if (searchTerm) {
                let textMatch = false;
                for (let j = 0; j < cells.length; j++) {
                    const cellText = cells[j].textContent.toLowerCase();
                    if (cellText.includes(searchTerm)) {
                        textMatch = true;
                        break;
                    }
                }
                if (!textMatch) matchFound = false;
            }

            // 检查年份筛选
            if (selectedYear && cells[0].textContent.toLowerCase() !== selectedYear) {
                matchFound = false;
            }

            // 检查品牌筛选
            if (selectedMake && cells[1].textContent.toLowerCase() !== selectedMake) {
                matchFound = false;
            }

            // 检查车型筛选
            if (selectedModel && cells[2].textContent.toLowerCase() !== selectedModel) {
                matchFound = false;
            }

            // 显示/隐藏行
            row.style.display = matchFound ? '' : 'none';
        }

        updateVisibleCount();
    }

    // 事件监听器
    if (searchInput) {
        searchInput.addEventListener('input', performFilter);
    }

    if (makeSelect) {
        makeSelect.addEventListener('change', performFilter);
    }

    if (yearSelect) {
        yearSelect.addEventListener('change', performFilter);
    }

    if (modelSelect) {
        modelSelect.addEventListener('change', performFilter);
    }

    if (filterBtn) {
        filterBtn.addEventListener('click', performFilter);
    }

    updateVisibleCount();
}